"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApolloClient = exports.isAbortError = void 0;
const client_1 = require("@apollo/client");
const incremental_1 = require("@apollo/client/incremental");
const context_1 = require("@apollo/client/link/context");
const error_1 = require("@apollo/client/link/error");
const ERROR_ENRICH_AI_PREFIX = 'ENRICH_AI';
const ABORT_LIKE_ERROR_PATTERN = /aborted|abort|err_network_changed|network changed/i;
const isAbortLikeText = (value) => (typeof value === 'string' && ABORT_LIKE_ERROR_PATTERN.test(value));
const isAbortError = (error) => {
    if (error instanceof Error) {
        return error.name === 'AbortError'
            || isAbortLikeText(error.message);
    }
    if (typeof error === 'object' && error !== null) {
        const errorLike = error;
        const name = typeof errorLike.name === 'string' ? errorLike.name : '';
        const message = typeof errorLike.message === 'string' ? errorLike.message : '';
        if (name === 'AbortError' || isAbortLikeText(message)) {
            return true;
        }
        const networkError = errorLike.networkError;
        if (!networkError) {
            return false;
        }
        const networkErrorName = typeof networkError.name === 'string' ? networkError.name : '';
        const networkErrorMessage = typeof networkError.message === 'string' ? networkError.message : '';
        return networkErrorName === 'AbortError'
            || isAbortLikeText(networkErrorMessage);
    }
    return false;
};
exports.isAbortError = isAbortError;
const createErrorLink = (isNonPublicEnv, logError) => new error_1.ErrorLink(({ error }) => {
    if (client_1.CombinedGraphQLErrors.is(error)) {
        error.errors.forEach(({ message, locations, path }) => {
            const errorMessage = `[${ERROR_ENRICH_AI_PREFIX} GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${JSON.stringify(path)}`;
            if (isNonPublicEnv) {
                console.error(errorMessage);
            }
            logError(errorMessage);
        });
    }
    else if (error && !(0, exports.isAbortError)(error)) {
        logError(`[${ERROR_ENRICH_AI_PREFIX}]: ${error.message}`, error);
    }
});
const createApolloClient = (url, options) => {
    const { token, isNonPublicEnv, logError, cache, } = options;
    const httpLink = new client_1.HttpLink({
        uri: url,
    });
    const authLink = new context_1.SetContextLink(({ headers }) => {
        const safeHeaders = (headers !== null && headers !== void 0 ? headers : {});
        if (!token) {
            return { headers: safeHeaders };
        }
        return {
            headers: Object.assign(Object.assign({}, safeHeaders), { authorization: token ? `Bearer ${token}` : '' }),
        };
    });
    const errorLink = createErrorLink(isNonPublicEnv, logError);
    const client = new client_1.ApolloClient({
        link: client_1.ApolloLink.from([errorLink, authLink, httpLink]),
        cache,
        defaultOptions: {
            query: {
                fetchPolicy: 'network-only',
                errorPolicy: 'none',
            },
            watchQuery: {
                notifyOnNetworkStatusChange: true,
                fetchPolicy: 'network-only',
                errorPolicy: 'none',
            },
            mutate: {
                errorPolicy: 'none',
            },
        },
        devtools: { enabled: true },
        incrementalHandler: new incremental_1.Defer20220824Handler(),
    });
    return client;
};
exports.createApolloClient = createApolloClient;
